import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { InputAdornment, FormControl, InputBase } from '@mui/material'

function SearchInput(_props) {
  const { placeholder = 'Buscar alumno', disable = false, ...rest } = _props
  return (
    <FormControl className={'w-60'}>
      <InputBase
        name="search"
        placeholder={placeholder}
        type="text"
        color="primary"
        endAdornment={
          <InputAdornment position="end">
            <FontAwesomeIcon icon={faSearch} size="1x" />
          </InputAdornment>
        }
        {...rest}
      />
    </FormControl>
  )
}

export default SearchInput
